export const environment = {
  environment: 'development',
  production: false,
  API_BASE_URL: 'https://dev-portal-eu.firstorion.com/api/v1/portal',
  // Show/hide Secure Branded Calling (anti-spoof) UI.
  enableAntiSpoofing: false,

  // Cognito settings
  cognito: {
    authority:
      'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_MNj0WzYnc',
    clientId: '4t6g8papf6cm0hu2mqrout70jq',
    redirectUrl: 'https://dev-portal-eu.firstorion.com/auth/callback',
    postLogoutRedirectUri: 'https://dev-portal-eu.firstorion.com',
    postLoginRoute: 'https://dev-portal-eu.firstorion.com/auth/callback',
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    disablePkce: false,
    domain: 'dev-icip',
    region: 'eu-west-1',
  },

  //reCAPTCHA settings
  recaptchaSiteKey: '6Lc1sDcsAAAAADp9ON3ixspmB1ceynOKIi_bmlJt',

  stripePublishableKey:
    'pk_test_51TtqE5BrIoroIzdsv0zV2fgDuM4g2mZGvpIYtw9pgLVW9rpRkoTVl4eWL2wjTCqreFopQOs1UntyI4ZRZjsyXhBL00b682Pk0p',
};
